import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

export type FullscreenLoadingOverlayProps = {
  message: string;
};

/**
 * Full-screen loading state aligned with the active MUI theme.
 */
function FullscreenLoadingOverlay({ message }: FullscreenLoadingOverlayProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Backdrop
      open
      sx={{
        zIndex: (muiTheme) => muiTheme.zIndex.modal + 1,
        flexDirection: "row",
        gap: 2,
        px: 3,
        color: isDark ? theme.palette.common.white : theme.palette.text.primary,
        backgroundColor: isDark ? "rgba(0, 0, 0, 0.8)" : "rgba(255, 255, 255, 0.92)",
        backdropFilter: "blur(2px)",
      }}
    >
      <CircularProgress color={isDark ? "inherit" : "primary"} size={40} />
      <Typography
        variant="body1"
        component="span"
        fontWeight={500}
        sx={{ color: "inherit" }}
      >
        {message}
      </Typography>
    </Backdrop>
  );
}

export default FullscreenLoadingOverlay;
